import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityControlList } from '@/common/entities/entityControl/EntityControlList';
import { InvLineList } from '@/sc/entities/invLine/InvLineList';


export const InvDetail = () => {
  
  const { entityObj } = useEntityMgr();
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'invLine', label: 'Lines', content: <InvLineList invObj={entityObj}/>},
    { id: 'soxControlsTab', label: 'SOX Controls', content: <EntityControlList parentEntity="INV" parentEntityId={entityObj.id} /> }
  ];


  return (
    <EntityDetail tabSpecs={tabSpecs}/>
  )
}